/**
 * Returns time from Navigation start.
 * Required for the purpose of measuring key metrics from the time page fetch starts.
 */
export function getTimeFromNavigationStart(timeMeasured?: number): number {
    const currentTime = timeMeasured ?? performance.now();
    return currentTime - window.performance?.timing?.navigationStart;
}
